import { render, staticRenderFns } from "./mainmodal.vue?vue&type=template&id=45ce8dd4&"
import script from "./mainmodal.vue?vue&type=script&lang=js&"
export * from "./mainmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports